module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_5012.2ea8849c.png";